<template>
    <div>
        <!-- <SelectField
            v-model="modelValue.account_uid"
            name="account_title"
            label="recipient"
            help="help_transfer_investment_account_title"
            :options="accountSelectOptions"
            :required="true"
            :on-search="loadAccountSelectOptions"
        /> -->
        <TextField
            v-model="modelValue.profile_id"
            name="profile_title"
            label="recipient"
            help="help_transfer_investment_profile_title"
            :required="true"
        />
        <div
            v-if="profile.name"
            class="flex flex-col gap-2"
        >
            <div class="flex items-center gap-2">
                <fa
                    v-if="profile.type === 'legal'"
                    icon="fa-building"
                />
                <fa
                    v-if="profile.type === 'natural'"
                    icon="fa-user"
                />
                <a
                    :href="profile.url"
                    target="_blank"
                    class="text-blue-500"
                >
                    {{ profile.name }}
                </a>
            </div>
        </div>
        <ToggleSwitch
            v-model="modelValue.keep_original_order"
            name="keep_original_order"
            label="keep_original_order"
            help="help_keep_original_order"
        />
        <TextField
            v-model="modelValue.message"
            name="message"
            label="transaction_message"
            help="help_transaction_message"
        />
    </div>
</template>

<script setup lang="ts">
import { TextField, ToggleSwitch } from '@src/components'
import { TransferOrder } from '@src/types'
import { checkProfile } from '@src/utils/api/accounts'
import { useLoadingStore } from '@src/utils/stores/loading'
import { reactive, ref, Ref, toRefs, watch } from 'vue'

const props = defineProps<{
    modelValue: Ref<TransferOrder>
}>()

type Profile = {
    name: string
    type: 'legal' | 'natural'
    url: string
}

const { modelValue } = toRefs(props)

const loadingStore = useLoadingStore()

const profileTimeout = ref<ReturnType<typeof setTimeout> | null>(null)
const profile = reactive<Profile>({
    name: '',
    type: 'natural',
    url: '',
})

// const i18n = useI18n()

// const accountSelectOptions = ref<{ label: string; value: string | null }[]>([])

// async function loadAccountSelectOptions(search: string) {
//     const request = await getAccounts({
//         'filter[account_title]': search,
//         // 'filter[wallet_status]': WalletStatus.WALLET_STATUS_KYC2,
//         'filter[platform_name_exact]': modelValue.value.platform_name,
//     })
//     accountSelectOptions.value = request.data.accounts.map(
//         (account: Account) => {
//             const accountType = account.legal_profile_uid
//                 ? 'legal_profile'
//                 : 'natural_profile'
//             return {
//                 label: `${account.account_title} - ${i18n.t(accountType)} (${
//                     account.account_uid
//                 })`,
//                 value: account.account_uid,
//             }
//         }
//     )
// }

watch(
    () => modelValue.value.profile_id,
    (newVal) => {
        if (profileTimeout.value) {
            clearTimeout(profileTimeout.value)
        }
        profileTimeout.value = setTimeout(async () => {
            loadingStore.setLoading(true)
            try {
                const result = await checkProfile(newVal ?? '')
                profile.type = result.data.profile.type
                profile.name = result.data.profile.name
                profile.url =
                    result.data.profile.type === 'legal'
                        ? `/legalProfile/${result.data.profile.id}`
                        : `/naturalProfile/${result.data.profile.id}`
            } catch (error) {
                profile.type = 'natural'
                profile.name = ''
            } finally {
                loadingStore.setLoading(false)
            }
        }, 1000)
    }
)
</script>

<style scoped></style>
